import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import client from "@/data/client";
import { enqueueSnackbar } from "notistack";
import routes from "@/config/routes.ts";
import { AxiosError } from "axios";
import { BookedIELTS, DefaultErrorResponse } from "@/types";
import API_ENDPOINTS from "@/data/client/endpoints.ts";

export function useBookExamMutation() {
  const Navigate = useNavigate();

  return useMutation(client.ielts.bookIELTS, {
    onSuccess: (data) => {
      if (data.status !== 200) {
        enqueueSnackbar("Something went wrong. please retry", {
          variant: "error",
        });
        return;
      }

      enqueueSnackbar("Exam booked successfully", {
        variant: "success",
      });

      Navigate(
        routes.book_exam_details.replace(":id", data.item.id.toString()),
        {
          state: data.item,
        },
      );
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}

export function useBookedIELTS() {
  const { data, isLoading, error } = useQuery<BookedIELTS, Error>(
    [API_ENDPOINTS.BOOKED_IELTS],
    client.ielts.bookedIELTS,
  );
  return {
    booked: data,
    isLoading,
    error,
  };
}

export function useDeleteBookExamMutation() {
  const Navigate = useNavigate();

  return useMutation(client.ielts.removeBookIELTS, {
    onSuccess: (data) => {
      if (data.status !== 200) {
        enqueueSnackbar("Something went wrong. please retry", {
          variant: "error",
        });
        return;
      }

      enqueueSnackbar("Exam booking removed successfully", {
        variant: "success",
      });

      Navigate(routes.book_exam);
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}

export function useUploadPicBookExamMutation() {
  return useMutation(client.ielts.uploadPicBookIELTS, {
    onSuccess: (data) => {
      if (data.status !== 200) {
        enqueueSnackbar("Something went wrong. please retry", {
          variant: "error",
        });
        return;
      }

      enqueueSnackbar("Picture uploaded successfully", {
        variant: "success",
      });
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}
